import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults, validateParameters } from './../wayfinder'
/**
* @see \App\Http\Controllers\FamilyHomeController::__invoke
* @see app/Http/Controllers/FamilyHomeController.php:9
* @route '//{url}.awraq.app'
*/
export const familyHome = (args: { url: string | number } | [url: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: familyHome.url(args, options),
    method: 'get',
})

familyHome.definition = {
    methods: ["get","head"],
    url: '//{url}.awraq.app',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FamilyHomeController::__invoke
* @see app/Http/Controllers/FamilyHomeController.php:9
* @route '//{url}.awraq.app'
*/
familyHome.url = (args: { url: string | number } | [url: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { url: args }
    }

    if (Array.isArray(args)) {
        args = {
            url: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        url: args.url,
    }

    return familyHome.definition.url
            .replace('{url}', parsedArgs.url.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\FamilyHomeController::__invoke
* @see app/Http/Controllers/FamilyHomeController.php:9
* @route '//{url}.awraq.app'
*/
familyHome.get = (args: { url: string | number } | [url: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: familyHome.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FamilyHomeController::__invoke
* @see app/Http/Controllers/FamilyHomeController.php:9
* @route '//{url}.awraq.app'
*/
familyHome.head = (args: { url: string | number } | [url: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: familyHome.url(args, options),
    method: 'head',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/admin/pulse'
*/
export const pulse = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

pulse.definition = {
    methods: ["get","head"],
    url: '/admin/pulse',
} satisfies RouteDefinition<["get","head"]>

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/admin/pulse'
*/
pulse.url = (options?: RouteQueryOptions) => {
    return pulse.definition.url + queryParams(options)
}

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/admin/pulse'
*/
pulse.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: pulse.url(options),
    method: 'get',
})

/**
* @see vendor/laravel/pulse/src/PulseServiceProvider.php:116
* @route '/admin/pulse'
*/
pulse.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: pulse.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\HealthController::__invoke
* @see app/Http/Controllers/HealthController.php:12
* @route '/up'
*/
export const health = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: health.url(options),
    method: 'get',
})

health.definition = {
    methods: ["get","head"],
    url: '/up',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\HealthController::__invoke
* @see app/Http/Controllers/HealthController.php:12
* @route '/up'
*/
health.url = (options?: RouteQueryOptions) => {
    return health.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\HealthController::__invoke
* @see app/Http/Controllers/HealthController.php:12
* @route '/up'
*/
health.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: health.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\HealthController::__invoke
* @see app/Http/Controllers/HealthController.php:12
* @route '/up'
*/
health.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: health.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\WelcomeController::welcome
* @see app/Http/Controllers/WelcomeController.php:12
* @route '/'
*/
export const welcome = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

welcome.definition = {
    methods: ["get","head"],
    url: '/',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WelcomeController::welcome
* @see app/Http/Controllers/WelcomeController.php:12
* @route '/'
*/
welcome.url = (options?: RouteQueryOptions) => {
    return welcome.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\WelcomeController::welcome
* @see app/Http/Controllers/WelcomeController.php:12
* @route '/'
*/
welcome.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: welcome.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WelcomeController::welcome
* @see app/Http/Controllers/WelcomeController.php:12
* @route '/'
*/
welcome.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: welcome.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Auth\User\LogoutController::__invoke
* @see app/Http/Controllers/Auth/User/LogoutController.php:14
* @route '/auth/logout'
*/
export const logout = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

logout.definition = {
    methods: ["post"],
    url: '/auth/logout',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Auth\User\LogoutController::__invoke
* @see app/Http/Controllers/Auth/User/LogoutController.php:14
* @route '/auth/logout'
*/
logout.url = (options?: RouteQueryOptions) => {
    return logout.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Auth\User\LogoutController::__invoke
* @see app/Http/Controllers/Auth/User/LogoutController.php:14
* @route '/auth/logout'
*/
logout.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: logout.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\TreeStudioReview\LegacyFileController::paperTreeLegacyFile
* @see app/Http/Controllers/TreeStudioReview/LegacyFileController.php:22
* @route '/family-paper-trees/{poster}/legacy/{kind}'
*/
export const paperTreeLegacyFile = (args: { poster: string | number, kind: string | number } | [poster: string | number, kind: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: paperTreeLegacyFile.url(args, options),
    method: 'get',
})

paperTreeLegacyFile.definition = {
    methods: ["get","head"],
    url: '/family-paper-trees/{poster}/legacy/{kind}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\TreeStudioReview\LegacyFileController::paperTreeLegacyFile
* @see app/Http/Controllers/TreeStudioReview/LegacyFileController.php:22
* @route '/family-paper-trees/{poster}/legacy/{kind}'
*/
paperTreeLegacyFile.url = (args: { poster: string | number, kind: string | number } | [poster: string | number, kind: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            poster: args[0],
            kind: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        poster: args.poster,
        kind: args.kind,
    }

    return paperTreeLegacyFile.definition.url
            .replace('{poster}', parsedArgs.poster.toString())
            .replace('{kind}', parsedArgs.kind.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\TreeStudioReview\LegacyFileController::paperTreeLegacyFile
* @see app/Http/Controllers/TreeStudioReview/LegacyFileController.php:22
* @route '/family-paper-trees/{poster}/legacy/{kind}'
*/
paperTreeLegacyFile.get = (args: { poster: string | number, kind: string | number } | [poster: string | number, kind: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: paperTreeLegacyFile.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\TreeStudioReview\LegacyFileController::paperTreeLegacyFile
* @see app/Http/Controllers/TreeStudioReview/LegacyFileController.php:22
* @route '/family-paper-trees/{poster}/legacy/{kind}'
*/
paperTreeLegacyFile.head = (args: { poster: string | number, kind: string | number } | [poster: string | number, kind: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: paperTreeLegacyFile.url(args, options),
    method: 'head',
})

/**
* @see routes/local.php:51
* @route '/dev-login/{tenantId?}'
*/
export const devLogin = (args?: { tenantId?: string | number } | [tenantId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: devLogin.url(args, options),
    method: 'get',
})

devLogin.definition = {
    methods: ["get","head"],
    url: '/dev-login/{tenantId?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:51
* @route '/dev-login/{tenantId?}'
*/
devLogin.url = (args?: { tenantId?: string | number } | [tenantId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { tenantId: args }
    }

    if (Array.isArray(args)) {
        args = {
            tenantId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "tenantId",
    ])

    const parsedArgs = {
        tenantId: args?.tenantId,
    }

    return devLogin.definition.url
            .replace('{tenantId?}', parsedArgs.tenantId?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see routes/local.php:51
* @route '/dev-login/{tenantId?}'
*/
devLogin.get = (args?: { tenantId?: string | number } | [tenantId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: devLogin.url(args, options),
    method: 'get',
})

/**
* @see routes/local.php:51
* @route '/dev-login/{tenantId?}'
*/
devLogin.head = (args?: { tenantId?: string | number } | [tenantId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: devLogin.url(args, options),
    method: 'head',
})

/**
* @see routes/local.php:60
* @route '/qa-login'
*/
export const qaLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qaLogin.url(options),
    method: 'get',
})

qaLogin.definition = {
    methods: ["get","head"],
    url: '/qa-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:60
* @route '/qa-login'
*/
qaLogin.url = (options?: RouteQueryOptions) => {
    return qaLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:60
* @route '/qa-login'
*/
qaLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qaLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:60
* @route '/qa-login'
*/
qaLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: qaLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:66
* @route '/qa-admin-login'
*/
export const qaAdminLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qaAdminLogin.url(options),
    method: 'get',
})

qaAdminLogin.definition = {
    methods: ["get","head"],
    url: '/qa-admin-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:66
* @route '/qa-admin-login'
*/
qaAdminLogin.url = (options?: RouteQueryOptions) => {
    return qaAdminLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:66
* @route '/qa-admin-login'
*/
qaAdminLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: qaAdminLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:66
* @route '/qa-admin-login'
*/
qaAdminLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: qaAdminLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:84
* @route '/tutorials-login/{mobile}'
*/
export const tutorialsLogin = (args: { mobile: string | number } | [mobile: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tutorialsLogin.url(args, options),
    method: 'get',
})

tutorialsLogin.definition = {
    methods: ["get","head"],
    url: '/tutorials-login/{mobile}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:84
* @route '/tutorials-login/{mobile}'
*/
tutorialsLogin.url = (args: { mobile: string | number } | [mobile: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { mobile: args }
    }

    if (Array.isArray(args)) {
        args = {
            mobile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        mobile: args.mobile,
    }

    return tutorialsLogin.definition.url
            .replace('{mobile}', parsedArgs.mobile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see routes/local.php:84
* @route '/tutorials-login/{mobile}'
*/
tutorialsLogin.get = (args: { mobile: string | number } | [mobile: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: tutorialsLogin.url(args, options),
    method: 'get',
})

/**
* @see routes/local.php:84
* @route '/tutorials-login/{mobile}'
*/
tutorialsLogin.head = (args: { mobile: string | number } | [mobile: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: tutorialsLogin.url(args, options),
    method: 'head',
})

/**
* @see routes/local.php:98
* @route '/large-tree-login'
*/
export const largeTreeLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: largeTreeLogin.url(options),
    method: 'get',
})

largeTreeLogin.definition = {
    methods: ["get","head"],
    url: '/large-tree-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:98
* @route '/large-tree-login'
*/
largeTreeLogin.url = (options?: RouteQueryOptions) => {
    return largeTreeLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:98
* @route '/large-tree-login'
*/
largeTreeLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: largeTreeLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:98
* @route '/large-tree-login'
*/
largeTreeLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: largeTreeLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:104
* @route '/huge-tree-login'
*/
export const hugeTreeLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: hugeTreeLogin.url(options),
    method: 'get',
})

hugeTreeLogin.definition = {
    methods: ["get","head"],
    url: '/huge-tree-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:104
* @route '/huge-tree-login'
*/
hugeTreeLogin.url = (options?: RouteQueryOptions) => {
    return hugeTreeLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:104
* @route '/huge-tree-login'
*/
hugeTreeLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: hugeTreeLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:104
* @route '/huge-tree-login'
*/
hugeTreeLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: hugeTreeLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:110
* @route '/node-near-limit-login'
*/
export const nodeNearLimitLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: nodeNearLimitLogin.url(options),
    method: 'get',
})

nodeNearLimitLogin.definition = {
    methods: ["get","head"],
    url: '/node-near-limit-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:110
* @route '/node-near-limit-login'
*/
nodeNearLimitLogin.url = (options?: RouteQueryOptions) => {
    return nodeNearLimitLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:110
* @route '/node-near-limit-login'
*/
nodeNearLimitLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: nodeNearLimitLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:110
* @route '/node-near-limit-login'
*/
nodeNearLimitLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: nodeNearLimitLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:116
* @route '/node-limit-login'
*/
export const nodeLimitLogin = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: nodeLimitLogin.url(options),
    method: 'get',
})

nodeLimitLogin.definition = {
    methods: ["get","head"],
    url: '/node-limit-login',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:116
* @route '/node-limit-login'
*/
nodeLimitLogin.url = (options?: RouteQueryOptions) => {
    return nodeLimitLogin.definition.url + queryParams(options)
}

/**
* @see routes/local.php:116
* @route '/node-limit-login'
*/
nodeLimitLogin.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: nodeLimitLogin.url(options),
    method: 'get',
})

/**
* @see routes/local.php:116
* @route '/node-limit-login'
*/
nodeLimitLogin.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: nodeLimitLogin.url(options),
    method: 'head',
})

/**
* @see routes/local.php:122
* @route '/dev-login-user/{userId}'
*/
export const devLoginUser = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: devLoginUser.url(args, options),
    method: 'get',
})

devLoginUser.definition = {
    methods: ["get","head"],
    url: '/dev-login-user/{userId}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see routes/local.php:122
* @route '/dev-login-user/{userId}'
*/
devLoginUser.url = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { userId: args }
    }

    if (Array.isArray(args)) {
        args = {
            userId: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        userId: args.userId,
    }

    return devLoginUser.definition.url
            .replace('{userId}', parsedArgs.userId.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see routes/local.php:122
* @route '/dev-login-user/{userId}'
*/
devLoginUser.get = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: devLoginUser.url(args, options),
    method: 'get',
})

/**
* @see routes/local.php:122
* @route '/dev-login-user/{userId}'
*/
devLoginUser.head = (args: { userId: string | number } | [userId: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: devLoginUser.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DebugPdfController::debugPdf
* @see app/Http/Controllers/DebugPdfController.php:20
* @route '/debug-pdf'
*/
export const debugPdf = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: debugPdf.url(options),
    method: 'get',
})

debugPdf.definition = {
    methods: ["get","head"],
    url: '/debug-pdf',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DebugPdfController::debugPdf
* @see app/Http/Controllers/DebugPdfController.php:20
* @route '/debug-pdf'
*/
debugPdf.url = (options?: RouteQueryOptions) => {
    return debugPdf.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DebugPdfController::debugPdf
* @see app/Http/Controllers/DebugPdfController.php:20
* @route '/debug-pdf'
*/
debugPdf.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: debugPdf.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DebugPdfController::debugPdf
* @see app/Http/Controllers/DebugPdfController.php:20
* @route '/debug-pdf'
*/
debugPdf.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: debugPdf.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\DebugClusteringController::debugClustering
* @see app/Http/Controllers/DebugClusteringController.php:18
* @route '/debug-clustering'
*/
export const debugClustering = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: debugClustering.url(options),
    method: 'get',
})

debugClustering.definition = {
    methods: ["get","head"],
    url: '/debug-clustering',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\DebugClusteringController::debugClustering
* @see app/Http/Controllers/DebugClusteringController.php:18
* @route '/debug-clustering'
*/
debugClustering.url = (options?: RouteQueryOptions) => {
    return debugClustering.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\DebugClusteringController::debugClustering
* @see app/Http/Controllers/DebugClusteringController.php:18
* @route '/debug-clustering'
*/
debugClustering.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: debugClustering.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\DebugClusteringController::debugClustering
* @see app/Http/Controllers/DebugClusteringController.php:18
* @route '/debug-clustering'
*/
debugClustering.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: debugClustering.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\AboutAppController::__invoke
* @see app/Http/Controllers/Tenant/AboutAppController.php:13
* @route '/user/about-app'
*/
export const aboutApp = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutApp.url(options),
    method: 'get',
})

aboutApp.definition = {
    methods: ["get","head"],
    url: '/user/about-app',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\AboutAppController::__invoke
* @see app/Http/Controllers/Tenant/AboutAppController.php:13
* @route '/user/about-app'
*/
aboutApp.url = (options?: RouteQueryOptions) => {
    return aboutApp.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\AboutAppController::__invoke
* @see app/Http/Controllers/Tenant/AboutAppController.php:13
* @route '/user/about-app'
*/
aboutApp.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: aboutApp.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\AboutAppController::__invoke
* @see app/Http/Controllers/Tenant/AboutAppController.php:13
* @route '/user/about-app'
*/
aboutApp.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: aboutApp.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Tenant\OnboardingController::__invoke
* @see app/Http/Controllers/Tenant/OnboardingController.php:12
* @route '/user/onboarding'
*/
export const onboarding = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: onboarding.url(options),
    method: 'get',
})

onboarding.definition = {
    methods: ["get","head"],
    url: '/user/onboarding',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Tenant\OnboardingController::__invoke
* @see app/Http/Controllers/Tenant/OnboardingController.php:12
* @route '/user/onboarding'
*/
onboarding.url = (options?: RouteQueryOptions) => {
    return onboarding.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Tenant\OnboardingController::__invoke
* @see app/Http/Controllers/Tenant/OnboardingController.php:12
* @route '/user/onboarding'
*/
onboarding.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: onboarding.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Tenant\OnboardingController::__invoke
* @see app/Http/Controllers/Tenant/OnboardingController.php:12
* @route '/user/onboarding'
*/
onboarding.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: onboarding.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Member\Mobile\RelationshipAnalysisController::__invoke
* @see app/Http/Controllers/Member/Mobile/RelationshipAnalysisController.php:19
* @route '/api/v1/mobile/relationship-analysis/analyze'
*/
export const analyze = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: analyze.url(options),
    method: 'post',
})

analyze.definition = {
    methods: ["post"],
    url: '/api/v1/mobile/relationship-analysis/analyze',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Member\Mobile\RelationshipAnalysisController::__invoke
* @see app/Http/Controllers/Member/Mobile/RelationshipAnalysisController.php:19
* @route '/api/v1/mobile/relationship-analysis/analyze'
*/
analyze.url = (options?: RouteQueryOptions) => {
    return analyze.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Member\Mobile\RelationshipAnalysisController::__invoke
* @see app/Http/Controllers/Member/Mobile/RelationshipAnalysisController.php:19
* @route '/api/v1/mobile/relationship-analysis/analyze'
*/
analyze.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: analyze.url(options),
    method: 'post',
})

